import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/school-match/Index.vue')
const Intro = () => import('../activity/school-match/Intro.vue')
const Records = () => import('../activity/school-match/Records.vue')
const Share = () => import('../activity/school-match/SharePage.vue')

export const indexRoute: RouteConfig = {
  path: '/school-match',
  name: 'school_match',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '校内赛',
    needLogin: true,
  },
}

export const introRoute: RouteConfig = {
  path: '/school-match/intro',
  name: 'school_match_intro',
  component: Intro,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '校内运动会',
    needLogin: true,
  },
}

export const shareRoute: RouteConfig = {
  path: '/school-match/share',
  name: 'school_match_share',
  component: Share,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '校内运动会',
  },
}

export const recordsRoute: RouteConfig = {
  path: '/school-match/records',
  name: 'school_match_records',
  component: Records,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '参赛记录',
    needLogin: true,
  },
}

export default [indexRoute, introRoute, recordsRoute, shareRoute]
